import { z } from 'zod'

import { ContactCategory } from '../types'
import { coreApiOutputEmailSchema } from '.'

// Contract contact persons, such as "Kiinteistöhuolto", "Isännöitsijä"
export const contactSchema = z.object({
  id: z.number(),
  name: z.string(),
  phoneNumber: z.string().nullable().optional(),
  email: coreApiOutputEmailSchema,
  serviceRole: z.string(),
  officeName: z.string(),
  url: z.string().optional(),
  contactCategory: z.nativeEnum(ContactCategory),
})

export const contactListSchema = z.array(contactSchema)

export type TContact = z.infer<typeof contactSchema>
